var map = {
	"./GenR会员协议.md": 6086,
	"./GenR用户协议.md": 5885,
	"./GenR隐私政策.md": 439,
	"./专注功能.md": 5926,
	"./监测功能.md": 4965,
	"./统计功能.md": 145
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8447;